import Vue from 'vue';

const states = Vue.observable({
    main_editmode: false
});

export default states;